
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.menu-toggle');
  const navMenu = document.querySelector('.nav-menu');

  // Toggle main menu on mobile
  menuToggle.addEventListener('click', () => {
    navMenu.classList.toggle('active');
  });

  // Toggle dropdowns on mobile
  const navItems = document.querySelectorAll('.nav-item');
  navItems.forEach(item => {
    const dropdown = item.querySelector('.dropdown');
    if (dropdown) {
      item.querySelector('.nav-link').addEventListener('click', e => {
        // Prevent default if dropdown exists
        e.preventDefault();
        item.classList.toggle('active');
      });
    }
  });
});



